<template>
  <div class="examEnter">
      <mt-navbar
        v-model="selected"
        fixed
      >
        <mt-tab-item id="test">考试</mt-tab-item>
        <mt-tab-item id="exercise">模拟</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="test">
          <div class="examItem stuInfo">
            <img
              src="../assets/imgs/userInfoIcon.png"
              alt=""
              class="userInfoIcon"
            >
            <span class="userTit">学员信息</span>
            <div v-if="isLogin">
              <p>学员学号:<span>{{idCard}}</span></p>
              <p>学员姓名:<span>{{username}}</span></p>
            </div>
            <div v-if="!isLogin">
              <p>学员学号:<span>未登录</span></p>
              <p>学员姓名:<span>未登录</span></p>
            </div>
          </div>
          <div v-if="isLogin">
            <div
              class="examItem"
              v-for="item in examlist"
              :key="item.index"
            >
              <div>
                <img
                  src="../assets/imgs/examIcon.png"
                  alt=""
                  class='examIcon'
                >
                <span class="userTit">{{item.title}}</span>
              </div>
              <div class="clearfix">
                <div class="fl">{{item.remark}}</div>
                <div class="fr">
                  <div
                    v-if="item.ispass ===2"
                    type="default"
                    class="examBtn btnToExam"
                  >考试合格</div>
                  <div
                    v-else-if="item.ispass === 0"
                    type="default"
                    class="examBtn btnToExam"
                  >未学完</div>
                  <div
                    v-else
                    type="default"
                    class="examBtn btnToExam"
                    @click="startexam(item.ispass,item.studyplanid,item.source,0)"
                  >参加考试</div>
                </div>
              </div>
            </div>
            <!-- <div class="examItem">
              <div>
                <img
                  src="../assets/imgs/examIcon.png"
                  alt=""
                  class='examIcon'
                >
                <span class="userTit">巡游网约车驾驶员继续教育模拟考试考试考试考试 试卷一</span>
              </div>
              <div class="clearfix">
                <div class="fl">巡游网约车</div>
                <div class="fr">
                  <mt-button
                    type="default"
                    class="examBtn"
                  >考试合格</mt-button>
                </div>
              </div>
            </div> -->
          </div>
          <div v-if="!isLogin">
            <router-link to="/login">
              <img
                src="../assets/imgs/toLoginIcon.png"
                alt=""
                class="toLoginIcon"
              >

              <img
                src="../assets/imgs/nonLoginTxt.png"
                alt=""
                class="nonLoginTxt"
              >
            </router-link>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="exercise">
          <div class="examItem stuInfo">
            <img
              src="../assets/imgs/userInfoIcon.png"
              alt=""
              class="userInfoIcon"
            >
            <span class="userTit">学员信息</span>
            <div v-if="isLogin">
              <p>学员学号:<span>{{idCard}}</span></p>
              <p>学员姓名:<span>{{username}}</span></p>
            </div>
            <div v-if="!isLogin">
              <p>学员学号:<span>未登录</span></p>
              <p>学员姓名:<span>未登录</span></p>
            </div>
          </div>
          <div v-if="isLogin">
            <div
              class="examItem"
              v-for="item in imitatelist"
              :key="item.index"
            >
              <div>
                <img
                  src="../assets/imgs/examIcon.png"
                  alt=""
                  class='examIcon'
                >
                <span class="userTit">{{item.title}}</span>
              </div>
              <div class="clearfix">
                <div class="fl">{{item.remark}}</div>
                <div class="fr">

                  <div
                    type="default"
                    class="examBtn btnToExam"
                    @click="startexam(item.ispass,item.studyplanid,item.source,1)"
                  >参加模拟</div>
                </div>
              </div>
            </div>
            <!-- <div class="examItem">
              <div>
                <img
                  src="../assets/imgs/examIcon.png"
                  alt=""
                  class='examIcon'
                >
                <span class="userTit">巡游网约车驾驶员继续教育模拟考试考试考试考试 试卷一</span>
              </div>
              <div class="clearfix">
                <div class="fl">巡游网约车</div>
                <div class="fr">
                  <mt-button
                    type="default"
                    class="examBtn"
                  >考试合格</mt-button>
                </div>
              </div>
            </div> -->
          </div>
          <div v-if="!isLogin">
            <router-link to="/login">
              <img
                src="../assets/imgs/toLoginIcon.png"
                alt=""
                class="toLoginIcon"
              >

              <img
                src="../assets/imgs/nonLoginTxt.png"
                alt=""
                class="nonLoginTxt"
              >
            </router-link>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>

    <tabbar></tabbar>
  </div>
</template>
<style  scoped>
.examEnter{
  padding-top:1.1rem;
}
.examEnter .stuInfo{
  margin: 0.1rem 0 0;
  border-radius: 0;
}
.examEnter .mint-navbar .mint-tab-item{
  margin: 0 20%;
}
</style>
<script>
import tabbar from '../components/tabbar.vue' // 引用组件的地址
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { getExamlist } from '../../src/api/Api'
import { mapGetters } from 'vuex'
export default {
  name: 'examEnter',
  components: {
    tabbar: tabbar
  },
  data () {
    return {
      myPageTit: '个人信息',
      isLogin: true,
      selected: 'test',
      idCard:
        sessionStorage.getItem('IdCard') !== '' &&
        sessionStorage.getItem('IdCard') !== null &&
        sessionStorage.getItem('IdCard') !== undefined
          ? sessionStorage.getItem('IdCard')
          : '--',
      username:
        sessionStorage.getItem('userName') !== '' &&
        sessionStorage.getItem('userName') !== null &&
        sessionStorage.getItem('userName') !== undefined
          ? sessionStorage.getItem('userName')
          : '--',
      examlist: [],
      imitatelist:[],
      spinner: false,
      baseUrl: window.baseapi.baseApiUrl,
    }
  },
  computed: {
    ...mapGetters(['platform'])
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.isLogin = false
    } else {
      this.isLogin = true
      sessionStorage.setItem('platform', '0')
      this.$store.dispatch('SetPlatform', 0);
      this.$store.dispatch('SetProfessionId',5)
      sessionStorage.setItem('professionId', 5)
      this.getExamlists()
      // if (this.platform !== '2') {

      // }
    }
  },
  destroyed () {
    Indicator.close()
  },
  methods: {
    getExamlists () {
      Indicator.open()
      var _this = this;
      var userId = sessionStorage.getItem('userId')
      getExamlist({
        uId: userId
      }).then(res => {
        if (res.data.returnCode === 1) {
          Indicator.close()
          _this.examlist = res.data.returnDate.examList
          _this.imitatelist = res.data.returnDate.imitateList
        } else {
          Indicator.close()
          Toast(res.data.returnMsg)
        }
      })
    },
    startexam (isPass,studyplanid,source,showanswer) {
      if (isPass === 0) {
        Toast('未达到计划课程时间')
        return false
      }
      MessageBox({
        title: '考试须知',
        message:
          '提示：请保持设备网络状况良好且电量充足，以免影响考试成绩。',
        showCancelButton: true,
        confirmButtonText: '开始考试',
        cancelButtonText: '稍作准备'
      }).then(action => {
        if (action === 'confirm') {
          // 确认的回调
          console.log(source);
          sessionStorage.setItem('platform', source) // 继续教育0  专项学习1
          this.$store.dispatch('SetPlatform', source)
          this.$router.push({
            path: '/test',
            query: { type: 0, platform: sessionStorage.getItem('platform'),studyplanid:studyplanid,stuid: sessionStorage.getItem('userId'),showanswer:showanswer }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ExamEnter.vue